export default "ORI - Umbanda Temple Management";
